import { cn } from "@omni/utils/styles";

import { GridContainerProps } from "./gridContainer.props";

const GridContainer = ({ children }: GridContainerProps) => {
    return (
        <div
            className={cn(
                "tw:flex tw:flex-col tw:md:grid tw:md:items-start tw:md:grid-rows-[auto]",
                "tw:md:grid-cols-[repeat(2,minmax(10px,1fr))] tw:md:gap-3.75",
                "tw:lg:grid-cols-[repeat(3,minmax(10px,1fr))]",
                "tw:space-y-3.75 tw:md:space-y-0"
            )}
        >
            {children}
        </div>
    );
};

export { GridContainer };
